import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-centers-center-new-schedule',
  templateUrl: './centers-center-new-schedule.component.html',
  styleUrls: ['./centers-center-new-schedule.component.scss']
})
export class CentersCenterNewScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
